import { render, staticRenderFns } from "./SupportsCreateDialog.vue?vue&type=template&id=3b999ca3&scoped=true&"
import script from "./SupportsCreateDialog.vue?vue&type=script&lang=js&"
export * from "./SupportsCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b999ca3",
  null
  
)

export default component.exports